import { RouteObject } from "react-router"
import MainPanel from "./mainPanel.view"
import { rotas,menuRotas } from "../../services/router"
import { MainMenu } from "../../data.types"
import { Dashboard } from "@mui/icons-material"

export enum PathRotaMain {
    main = "/main"
}

const routerMain: RouteObject = {
    path: PathRotaMain.main,
    element: <MainPanel/>,
}


export const navigationToMainView = ()=> rotas.navigate(PathRotaMain.main)

export function startRouterMain(){
    const menu:MainMenu = {
        text:"Painel Demostrativo",
        icon:<Dashboard />,
        eventOnClick:navigationToMainView
    }
    menuRotas.push(menu);
    return routerMain
}